 <template>
  <div>
    <div class="box_bgd" @click="isC">
      <i class="el-icon-s-fold" v-show="block"></i>
      <i class="el-icon-s-unfold" v-show="toggle"></i>
    </div>

    <el-menu
      :default-active="activeMenuIndex"
      :router="true"
      unique-opened
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      collapse-transition
    >
      <template v-for="menu in sidebarRouters">
        <el-menu-item
          :index="menu.path"
          :key="menu.id"
          v-if="menu.children == null"
        >
          <i style="margin-left: 4px" class="iconfont" :class="menu.icon"></i>
          <span
            slot="title"
            :index="menu.path"
            style="margin-left: 10px"
            >{{ menu.componentName }}</span
          >
        </el-menu-item>
        <el-submenu
          v-if="menu.children != null"
          :index="menu.path"
          :key="menu.id"
        >
          <template slot="title">
            <i style="margin-left: 4px" class="iconfont" :class="menu.icon"></i>
            <span style="margin-left: 8px">{{ menu.componentName }}</span>
          </template>
          <div
            v-for="ccmenu in menu.children"
            :key="ccmenu.id"
            :index="menu.path"
          >
            <el-menu-item-group v-if="ccmenu.children == null">
              <el-menu-item :index="ccmenu.path" style="margin-top: -14px">
                <i
                  style="margin-left: 14px;font-size:15px"
                  class="iconfont"
                  :class="ccmenu.icon"
                ></i>
                <span style="margin-left: 8px">{{ ccmenu.componentName }}</span>
              </el-menu-item>
            </el-menu-item-group>
            <el-submenu :index="ccmenu.path" v-if="ccmenu.children != null">
              <template slot="title">
                <i
                  style="margin-left: 4px"
                  class="iconfont"
                  :class="ccmenu.icon"
                ></i>
                <span class="mm" style="margin-left: 10px">{{
                  ccmenu.componentName
                }}</span>
              </template>

              <el-menu-item
                v-for="tmenus in ccmenu.children"
                :key="tmenus.id"
                :index="tmenus.path"
              >
                <span style="margin-left: 15px" :index="tmenus.path">{{
                  tmenus.componentName
                }}</span>
              </el-menu-item>
            </el-submenu>
          </div>
        </el-submenu>
      </template>
    </el-menu>

    <!-- <ul v-if="leftindex=='1'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/property/property-management',0)">物业管理</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/property/flowing-water',1)">物业流水</li>
        <li :id="leftactive==2?'active':''"  @click="toPath('/property/separate-accounts',2)">分账详情</li>
        <li :id="leftactive==3?'active':''"  @click="toPath('/property/alipay-liushui',3)">支付宝流水</li>
        <li :id="leftactive==4?'active':''"  @click="toPath('/property/wechat-bill',4)">微信账单</li>
        <li :id="leftactive==5?'active':''"  @click="toPath('/property/alipay-bill',5)">支付宝账单</li>
        <li :id="leftactive==6?'active':''" @click="toPath('/property/etc-bill',6)" >ETC账单</li>
        <li :id="leftactive==7?'active':''"  @click="toPath('/property/coupon-bill',7)">优惠劵账单</li>
      </ul>
      <ul v-if="leftindex=='2'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/carpark/yard-management',0)">车场管理</li>
        <li :id="leftactive==3?'active':''"  @click="toPath('/carpark/parking-space',3)">车位管理</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/carpark/police-box',1)">岗亭管理</li >
        <li :id="leftactive==2?'active':''"  @click="toPath('/carpark/configuration',2)">车道配置</li>

        <li>支付管理</li>
        <li>设备状态</li>
        <li :id="leftactive==4?'active':''"  @click="toPath('/carpark/billing-rules',4)">规则计费</li>
      </ul>
      <ul v-if="leftindex=='3'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/personnel/all',0)">所有人员</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/personnel/property',1)">物业人员</li>
        <li :id="leftactive==2?'active':''"  @click="toPath('/personnel/yard',2)">车场人员</li >
        <li :id="leftactive==3?'active':''"  @click="toPath('/personnel/boot',3)">岗亭人员</li>
        <li :id="leftactive==4?'active':''"  @click="toPath('/personnel/h5',4)">H5人员</li>
        <li :id="leftactive==5?'active':''"  @click="toPath('/personnel/operation',5)">运维人员</li>
        <li :id="leftactive==6?'active':''"  @click="toPath('/personnel/role',6)">角色管理</li>
      </ul>
      <ul v-if="leftindex=='6'">
        <li :id="leftactive==4?'active':''"  @click="toPath('/report-forms/parking',4)">泊车订单</li>
        <li :id="leftactive==5?'active':''"  @click="toPath('/report-forms/predetermine',5)">预定车位订单</li >
          <li :id="leftactive==6?'active':''"  @click="toPath('/report-forms/payment-order',6)">支付订单</li>
          <li :id="leftactive==7?'active':''"  @click="toPath('/report-forms/refund-order',7)">退款订单</li>
        <li :id="leftactive==0?'active':''"  @click="toPath('/report-forms/parking-report',0)">停车报表</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/report-forms/evasion-statement',1)">逃单报表</li >
        <li :id="leftactive==2?'active':''"  @click="toPath('/report-forms/card-package',2)">卡套餐报表</li>
        <li :id="leftactive==3?'active':''"  @click="toPath('/report-forms/abnormal-report',3)">异常报表</li>

      </ul>
      <ul v-if="leftindex=='8'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/combo-meal/card-package',0)">卡套餐</li>
      </ul>
      <ul v-if="leftindex=='9'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/record/go-out',0)">进出记录</li>
        <li :id="leftactive==6?'active':''"  @click="toPath('/record/secondary-scanning',6)">二次扫码记录</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/record/off-site',1)">离场记录</li>
        <li :id="leftactive==2?'active':''"  @click="toPath('/record/get-into',2)">在场记录</li>
        <li :id="leftactive==3?'active':''"  @click="toPath('/record/opening-record',3)">开闸记录</li>
        <li :id="leftactive==4?'active':''"  @click="toPath('/record/equipment-record',4)">控制器消息记录</li>
        <li :id="leftactive==5?'active':''"  @click="toPath('/record/abnormal-vehicle',5)">异常车辆</li>
      </ul>
      <ul v-if="leftindex=='10'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/device/index',0)">设备列表</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/device/check-point',1)">车道关卡</li>
      </ul>
      <ul v-if="leftindex=='11'">
        <li :id="leftactive==0?'active':''"  @click="toPath('/order/repairs',0)">报修工单</li>
        <li :id="leftactive==1?'active':''"  @click="toPath('/order/park-car',1)">工单操作记录</li>


      </ul> -->
  </div>
</template>

 <script>
export default {
  data() {
    return {
      leftactive: 0,
      isCollapse: false,
      show: false,
      toggle: false, //第二个图标默认隐藏
      block: true, //默认显示第一个图标
      allmenu: [],
    };
  },
  // props: {
  //   parentValue: {
  //     type: String,
  //   },
  //   leftindex: {
  //     type: String,
  //     required: true,
  //   },
  // },
  computed: {
    activeMenuIndex() {
      return this.$store.state.permission.mainMenuModuleUrl;
    },
    // 所有的路由信息
    sidebarRouters() {
      return this.$store.state.permission.sidebarRouters;
    },
  },
  mounted() {
    this.getLeftIndex();
  },
  methods: {
    isC() {
      this.isCollapse = !this.isCollapse;
      this.$root.Bus.$emit("toggle", this.isCollapse);
      this.toggle = !this.toggle;
      this.block = !this.block;
    },
    changeShow() {
      console.log(111111111, this.isCollapse);
      this.isCollapse = !this.isCollapse;
      // this.show=!this.show
    },
    getLeftIndex() {
      this.leftactive = this.$route.query.leftactive;
      if (this.leftactive == undefined) {
        this.leftactive = 0;
      }
    },
    toPath(path, index) {
      this.leftactive = index;
      // this.$router.push({name: path, params: {leftactive: index}})
      this.$router.push({ path: path, query: { leftactive: index } });
    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [],
      msg: "success",
    };
    this.allmenu = res.data;
  },
};
</script>

 <style>
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: rgb(58, 58, 58);
}
/* 左边内容 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.leftnav {
  min-height: 94.5vh;
}
.box_bgd {
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  /* background: red; */
  cursor: pointer;
  margin: auto;
  width: 100%;
}
.box_bgd i {
  font-size: 20px;
}
.box_bgd:hover {
  background-color: rgb(203, 215, 230);
}
/* .leftnav li {
  padding: 17px 0px;
  border-right: 4px solid transparent;
}
.leftnav li:hover {
  background: #d1edff;
  border-right: 4px solid #0099ff;
  color: #0099ff;
}
#active {
  background: #d1edff;
  border-right: 4px solid #0099ff;
  color: #0099ff;
} */
.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
}
.el-menu {
  border-right: 0px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftNav.vue